import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoryPaymentComponent } from './story-payment.component';
import { PaymentModule } from '../payment/payment.module';
import { SharedModule } from '../../shared/shared.module';
import { ContactBeneficiaryModule } from '../contact-beneficiary/contact-beneficiary.module';
import { CurrencyDropdownModule } from '../currency-dropdown/currency-dropdown.module';
import { KettoAssuredV2Module } from '../ketto-assured-v2/ketto-assured-v2.module';
import { SupportersInfoModule } from '../supporters-info/supporters-info.module';
import { PaymentOtdModule } from '../payment-otd/payment-otd.module';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';



@NgModule({
  declarations: [StoryPaymentComponent],
  exports: [StoryPaymentComponent],
  imports: [
    CommonModule,
    PaymentModule,
    SharedModule,
    ContactBeneficiaryModule,
    CurrencyDropdownModule,
    KettoAssuredV2Module,
    SupportersInfoModule,
    PaymentOtdModule,
    ComponentLoader
  ]
})
export class StoryPaymentModule { }
